import { render, staticRenderFns } from "./foodAuthorDialog.vue?vue&type=template&id=5d547710&scoped=true&"
import script from "./foodAuthorDialog.vue?vue&type=script&lang=js&"
export * from "./foodAuthorDialog.vue?vue&type=script&lang=js&"
import style0 from "./foodAuthorDialog.vue?vue&type=style&index=0&id=5d547710&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d547710",
  null
  
)

export default component.exports